"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _map = _interopRequireDefault(require("lodash/map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function classify(...args) {
  return args.map(arg => {
    let mappedArg = arg;

    if ((0, _isPlainObject.default)(arg)) {
      // $FlowFixMe[incompatible-call] arg is an object
      mappedArg = (0, _map.default)(arg, (test, name) => test ? name : null);
    }

    return mappedArg;
  }).reduce((array, current) => {
    if (Array.isArray(current)) {
      array.push(...current);
    } else {
      array.push(current);
    }

    return array;
  }, []).filter(val => val).join(' ');
}

var _default = classify;
exports.default = _default;